import { useLocation, useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

// Dyskretny, globalny odnośnik „Wstecz" — wraca do poprzedniej strony (historia przeglądarki).
// Ukryty na stronach głównych oraz przy wejściu bezpośrednim (brak historii w aplikacji).
const HIDDEN = new Set(["/", "/sklep", "/sklep/logowanie", "/login"]);

export default function BackLink() {
  const navigate = useNavigate();
  const { pathname, key } = useLocation();
  if (HIDDEN.has(pathname)) return null;
  if (key === "default") return null;
  return (
    <button
      type="button"
      data-testid="global-back-link"
      onClick={() => navigate(-1)}
      aria-label="Wróć do poprzedniej strony"
      className="fixed left-2 sm:left-3 top-[4.6rem] z-30 flex items-center gap-1 rounded-full border border-black/10 bg-white/75 px-2.5 py-1.5 text-xs font-medium text-neutral-600 shadow-sm backdrop-blur transition-colors hover:text-neutral-900 hover:border-black/25 dark:border-white/15 dark:bg-white/10 dark:text-neutral-300 dark:hover:text-white"
    >
      <ChevronLeft className="h-4 w-4" />
      <span className="hidden sm:inline">Wstecz</span>
    </button>
  );
}
